/**
 * Product Upsell - One-Click Add to Cart
 *
 * Handles adding upsell products to cart without page navigation
 */

(function () {
  'use strict';

  function initProductUpsell() {
    const upsellButtons = document.querySelectorAll('[data-upsell-add]');

    upsellButtons.forEach(button => {
      button.addEventListener('click', handleUpsellAdd);
    });
  }

  async function handleUpsellAdd(e) {
    const button = e.currentTarget;
    const variantId = button.dataset.variantId;
    const productTitle = button.dataset.productTitle;

    if (!variantId) return;

    // Disable button and show loading state
    button.disabled = true;
    button.classList.add('product-upsell__button--loading');
    const originalText = button.innerHTML;

    try {
      // Add product to cart
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1
        })
      });

      if (!response.ok) {
        throw new Error('Failed to add product to cart');
      }

      const data = await response.json();

      // Show success message
      showMessage('success', `✓ ${productTitle} added to cart!`);

      // Update button text
      button.innerHTML = `
        <svg class="product-upsell__button-icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M3 8L6 11L13 4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span>Added!</span>
      `;
      button.style.background = '#2e7d32';

      // Update cart count if cart drawer/icon exists
      updateCartCount();

      // Reset button after 2 seconds
      setTimeout(() => {
        button.innerHTML = originalText;
        button.disabled = false;
        button.classList.remove('product-upsell__button--loading');
      }, 2000);

    } catch (error) {
      console.error('Upsell add error:', error);
      showMessage('error', 'Failed to add product. Please try again.');

      // Re-enable button
      button.innerHTML = originalText;
      button.disabled = false;
      button.classList.remove('product-upsell__button--loading');
    }
  }

  function showMessage(type, text) {
    const messageEl = document.getElementById('upsell-message');
    if (!messageEl) return;

    const messageText = messageEl.querySelector('.product-upsell__message-text');
    if (messageText) {
      messageText.textContent = text;
    }

    messageEl.className = 'product-upsell__message';
    messageEl.classList.add(`product-upsell__message--${type}`);
    messageEl.style.display = 'block';

    // Hide message after 4 seconds
    setTimeout(() => {
      messageEl.style.display = 'none';
    }, 4000);
  }

  async function updateCartCount() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();

      // Update cart count in header/drawer if exists
      const cartCountElements = document.querySelectorAll('[data-cart-count], .cart-count, #cart-count');
      cartCountElements.forEach(el => {
        el.textContent = cart.item_count;
        if (cart.item_count > 0) {
          el.style.display = '';
        }
      });

      // Dispatch cart update event for other components
      document.dispatchEvent(new CustomEvent('cart:updated', {
        detail: { cart }
      }));

    } catch (error) {
      console.error('Failed to update cart count:', error);
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductUpsell);
  } else {
    initProductUpsell();
  }
})();
